var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialSymbolsHourglassOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 20H16V17C16 15.9 15.6083 14.9583 14.825 14.175C14.0417 13.3917 13.1 13 12 13C10.9 13 9.95833 13.3917 9.175 14.175C8.39167 14.9583 8 15.9 8 17V20ZM12 11C13.1 11 14.0417 10.6083 14.825 9.825C15.6083 9.04167 16 8.1 16 7V4H8V7C8 8.1 8.39167 9.04167 9.175 9.825C9.95833 10.6083 10.9 11 12 11ZM4 22V20H6V17C6 15.9833 6.23767 15.029 6.713 14.137C7.18833 13.245 7.85067 12.5327 8.7 12C7.85 11.4667 7.18767 10.7543 6.713 9.863C6.23833 8.97167 6.00067 8.01733 6 7V4H4V2H20V4H18V7C18 8.01667 17.7627 8.971 17.288 9.863C16.8133 10.755 16.1507 11.4673 15.3 12C16.15 12.5333 16.8127 13.246 17.288 14.138C17.7633 15.03 18.0007 15.984 18 17V20H20V22H4Z",
    fill: "#748597"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsHourglassOutline);
export default __webpack_public_path__ + "static/media/material-symbols_hourglass-outline.f660d612d7f9486be61ee59e217605c1.svg";
export { ForwardRef as ReactComponent };